import RfiActivityDrawer from './RfiActivityDrawer.component';

export default RfiActivityDrawer;
